import axios from '@/libs/api.request'
const staff = {
    // 完工人列表
    getStaff: () => {
        return axios.get({
            url: '/Staff'
        })
    }
}
export default staff


// WEBPACK FOOTER //
// ./src/api/api-staff.js